export default __webpack_public_path__ + "static/media/轮播首图12.7a5daecb.jpg";